export type IRequestParams = Record<string, number |string | boolean | string[] | number[]>;

export function buildParamString(requestParams: IRequestParams): string {
  return Object.keys(requestParams).reduce((result, key) => {
    const param = requestParams[key];
    // number 0 & boolean false worden toegevoegd
    if (param !== null && param !== undefined && param !== '') {
      result += (result.length > 0) ? '&' : '?';

      if (typeof param === 'string') {
        result += `${key}=${encodeURIComponent(param)}`;

      } else if (Array.isArray(param)) {
        result += `${key}=${encodeURIComponent(param.join(','))}`;

      } else {
        result += `${key}=${param as number}`;
      }
    }
    return result;
  }, '');
}
